import { useEffect, useState } from 'react';
import { PropTypes } from 'base/react-libs';
import JourneyDetailTableBody from './journey-detail-table-body';
import JourneyDetailTableHeader from './journey-detail-table-header';
import { useGlobalJourneyProvider } from 'apps/journeys/context/global-journey-context';

const TABS = [
  { id: 1, label: 'Your Constituents' },
  { id: 2, label: 'All Constituents' },
];

const JourneyDetailTable = ({
  user = {},
  journey = {},
  stepEmpty,
  userIsCreator = false,
  selectedContact,
  openContactSummary = () => {},
  optionalStateManagementFunction = () => {},
  setActiveFilter,
  actionTypes,
  activeFilter,
  viewSideBar,
  selectedDueDate,
  allSelectedTasks,
  setAllSelectedTasks,
  tableView,
  setTableView,
}) => {
  const { navigateFrom, setNavigateFrom } = useGlobalJourneyProvider();
  const [selectedTab, setSelectedTab] = useState(TABS[0]);

  useEffect(() => {
    if (navigateFrom) {
      if (!(user?.name === navigateFrom?.owner?.name)) {
        setTableView('activeConstituents');
        setSelectedTab(TABS[1]);
      }
    }
  }, [navigateFrom, setNavigateFrom, user, tableView, setTableView]);

  return (
    <div className="journey-detail-table--container">
      <JourneyDetailTableHeader
        journey={journey}
        tableView={tableView}
        setTableView={setTableView}
        setActiveFilter={setActiveFilter}
        actionTypes={actionTypes}
        activeFilter={activeFilter}
      />
      <JourneyDetailTableBody
        user={user}
        journey={journey}
        stepEmpty={stepEmpty}
        tableView={tableView}
        userIsCreator={userIsCreator}
        selectedContact={selectedContact}
        openContactSummary={openContactSummary}
        optionalStateManagementFunction={optionalStateManagementFunction}
        viewSideBar={viewSideBar}
        tabs={TABS}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        selectedDueDate={selectedDueDate}
        allSelectedTasks={allSelectedTasks}
        setAllSelectedTasks={setAllSelectedTasks}
      />
    </div>
  );
};

JourneyDetailTable.propTypes = {
  user: PropTypes.object,
  journey: PropTypes.object.isRequired,
  stepEmpty: PropTypes.bool,
  userIsCreator: PropTypes.bool,
  selectedContact: PropTypes.object,
  openContactSummary: PropTypes.func,
  optionalStateManagementFunction: PropTypes.func,
  setActiveFilter: PropTypes.func,
  actionTypes: PropTypes.array,
  activeFilter: PropTypes.array,
  viewSideBar: PropTypes.bool,
  selectedDueDate: PropTypes.number,
  allSelectedTasks: PropTypes.array,
  setAllSelectedTasks: PropTypes.func,
  setTableView: PropTypes.func,
  tableView: PropTypes.string,
};

export default JourneyDetailTable;
